export const DATE_OF_BIRTH_REQUIRED = 'Enter your date of birth';
export const PLACE_OF_BIRTH_REQUIRED = 'Enter your place of birth';
export const SELECT_REQUIRED = 'Select an option';
export const MULTISELECT_REQUIRED = 'Select some options';
export const DATE_FORMAT_ERROR = 'The date format is MM/DD/YYYY';
